import React from 'react';
import {
  OfferStyledCard,
  OfferContent,
  OfferTag,
  OfferTitle,
  OfferDescription,
  OfferCTA,
  OfferLink,
  OfferBackground,
  OfferImage
} from './styles';
import {
  truncate,
  isNonEmptyString,
  OfferData
} from '@uma/react-commons/dist/index';
import mountOfferPrice from './helpers/mountOfferPrice/mountOfferPrice';
import { useDependencyManagerContext } from 'src/contexts/dependencyManager';

interface OfferCardProps {
  offer: OfferData;
  isRtl: boolean;
  showPriceDeviceDetailsOffer: boolean;
  country: string;
  onClick: (offer: OfferData) => void;
}

const OfferCard: React.FC<OfferCardProps> = ({
  offer,
  isRtl,
  country,
  showPriceDeviceDetailsOffer,
  onClick
}) => {
  const { translate, northboundAPIs } = useDependencyManagerContext();
  const { title, description, hyperlinkText, storeUrl, imageUrl, price } =
    offer;

  const language = northboundAPIs.v1.localization.language;

  const tagText = translate('devices.offer.recommended', 'Recommended'); // For now, hardcoded tag text. Could be dynamic in the future.

  return (
    <OfferStyledCard
      onClick={() => onClick(offer)}
      tabIndex={0}
      role="button"
      aria-label="Offer card"
      childrenStyle={{ marginTop: '16px', align: 'left' }}
    >
      <OfferContent>
        <OfferTag
          label={tagText}
          maxWidth="100%"
          aria-label="Offer tag"
        />
        <OfferTitle
          className="label"
          title={title}
          aria-label="Title of the offer"
        >
          {truncate(title, 100)}
        </OfferTitle>
        {isNonEmptyString(description) && (
          <OfferDescription
            className="caption"
            title={description}
            aria-label="Description of the offer"
          >
            {truncate(description, 180)}
          </OfferDescription>
        )}
        {mountOfferPrice({
          showPriceDeviceDetailsOffer,
          price,
          country,
          language
        })}
        <OfferCTA>
          <OfferLink
            tabIndex={-1}
            href={storeUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Link to action"
            data-testid="offer-hyperlink"
          >
            {hyperlinkText}
          </OfferLink>
        </OfferCTA>
      </OfferContent>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <OfferBackground $rtl={isRtl}>
          <OfferImage
            src={imageUrl}
            alt={title}
          />
        </OfferBackground>
      </div>
    </OfferStyledCard>
  );
};

export default OfferCard;
